<template>
  <div>
  <h2>Offering Admin Settings</h2>
  <div class="form-group">
    <div class="checkbox checkbox-primary">
      <input type="checkbox" class="styled" name="offering-admin" v-model="formData.isOAdmin" @change="clearSelectedOfferings">
      <label>Offering Admin</label>
      <modal-help>
        Check the "offering admin" box to give this rep access to individual offerings.
        Choose at least one offering and then click confirm.
        Uncheck this box and click Confirm to remove all admin permissions.
      </modal-help>
    </div>
  </div>
    <div>
      <offering-list :offerings="offerings" @checkbox="getOfferings" v-if="formData.isOAdmin" :admin-offerings="adminOfferings"></offering-list>
      <input type="button" name="offeringAdminBtn" value="Confirm" @click="updateUser" class="btn btn-default margin-right-10" :disabled="formData.isOAdmin && toggleConfirm"/>
      <h5 v-show="isVisible" >{{ message }}</h5>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import OfferingList from "./OfferingList"
  import ModalHelp from "./ModalHelp";

export default {
  name: "OfferingAdmin",
  components: {
    ModalHelp,
    OfferingList,
  },
  props: {
    offerings: {
      type: Array,
      default: [],
    },
    repId: {
      type: Number,
      default: 0
    },
    isOfferingAdmin: {
      type: Boolean,
      default: false
    },
    adminOfferings: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      isVisible: false,
      message: '',
      formData: {
        isOAdmin: this.isOfferingAdmin,
        user_id: this.repId,
        selectedOfferings: [],
      },
    }
  },
  methods: {
    updateUser: function () {
      axios.post('setOfferingAdmin', this.formData)
        .then(response => {
          this.message = response.data.status
          this.isVisible = true
          this.timer()
          return Promise.resolve()
        })
    },
    getOfferings: function (data) {
      this.formData.selectedOfferings = data.slice(0)
    },
   clearSelectedOfferings: function () {
      if(!this.formData.isOAdmin) {
        this.formData.selectedOfferings = []
      }
   },
    timer() {
      setTimeout(() => {
        this.isVisible = false
        this.message = ''
      }, 3000)
    }
  },
  computed: {
    toggleConfirm: function () {
      return  !( this.formData.selectedOfferings.length >= 1);
    }
  },
  mounted() {
    if(this.adminOfferings.length > 0) {
      this.formData.selectedOfferings = this.adminOfferings.slice(0)
    }
  }
}
</script>